// Logarithmic mapping between linear slider position (0–100) and actual
// price values. Fashion catalogues have a long tail (most items in low
// range, fewer premium pieces), so a log curve gives the user finer
// control where most products live and still keeps the premium end
// reachable.
//
//   position 0%   → 0
//   position 25%  → ~86  (for max = 1000)
//   position 50%  → ~240
//   position 75%  → ~519
//   position 100% → 1000

export function positionToPrice(position: number, max: number): number {
  if (max <= 0) return 0;
  const clamped = Math.min(100, Math.max(0, position));
  const raw = (max * (Math.pow(10, clamped / 100) - 1)) / 9;
  return Math.round(raw);
}

export function priceToPosition(price: number, max: number): number {
  if (max <= 0) return 0;
  const clamped = Math.min(max, Math.max(0, price));
  return Math.log10(1 + (9 * clamped) / max) * 100;
}
